var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueFilledHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 2.38867C10.9725 2.38867 9.7575 3.04867 9 4.06117C8.6131 3.54278 8.11069 3.12172 7.53265 2.83139C6.95461 2.54107 6.31685 2.38949 5.67 2.38867C3.3675 2.38867 1.5 4.26367 1.5 6.58117C1.5 7.47367 1.6425 8.29867 1.89 9.06367C3.075 12.8137 6.7275 15.0562 8.535 15.6712C8.79 15.7612 9.21 15.7612 9.465 15.6712C11.2725 15.0562 14.925 12.8137 16.11 9.06367C16.3575 8.29867 16.5 7.47367 16.5 6.58117C16.5 4.26367 14.6325 2.38867 12.33 2.38867Z",
    fill: "#f9bc03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFilledHeart);
export default __webpack_public_path__ + "static/media/blueFilledHeart.ac8afc61e5343782c63502b19b15d37d.svg";
export { ForwardRef as ReactComponent };